import React, { useEffect, useMemo, FC } from 'react'

import { styled } from '@mui/system'
import { ObjectTypeEnum } from '../../../types/SubCondition'
import { OBJECT_TYPE_MAP, CustomFieldValue } from '../../../context/CustomField/CustomFieldTypes'
import AutoComplete from '../../../pixel/AutoComplete'
import useCustomFieldQuery from '../../../hooks/useCustomFieldQuery'
import { ValueError } from '../../../store/groupConditionsSlice'
import { useLocalizedText } from '../../../context/Localization/localizationHooks'
import { LocalizedText } from '../../../context/Localization/LocalizationTypes'
import { useViewModeReadOnly } from '../../../context/ViewMode/viewModeHooks'
import useTransformCustomFieldValues from '../../../hooks/useTransformCustomFieldValues'
import useTransformFieldValuesMap from '../../../hooks/useTransformFieldValuesMap'
import useCustomFieldQueryOnOpen from '../../../hooks/useCustomFieldQueryOnOpen'

const RootDropDownStatement = styled('div')(() => ({

}))

interface DropDownStatementProps {
    fieldEId: string
    objectType: ObjectTypeEnum
    values: Array<string>
    valueError: ValueError
    onChange: (newValues: Array<string>) => void
}
const DropDownStatement: FC<DropDownStatementProps> = (props) => {
    const AdminNoResults = useLocalizedText(LocalizedText.NoResults)
    const ValueLabel = useLocalizedText(LocalizedText.ValueLabel)
    const isReadOnly = useViewModeReadOnly()
    const {
        data: selectedData,
        resultsLoading: selectedResultsLoading,
        pageLoading: selectedPageLoading,
        fetchSelectedResults,
        setData
    } = useCustomFieldQuery({
        fieldEId: props.fieldEId,
        objectType: OBJECT_TYPE_MAP[props.objectType] as 'Candidate' | 'Job', // We know this will be either since this component wont render if not set
        valueEIds: props.values
    })

    const {
        data,
        resultsLoading,
        pageLoading,
        currentPage,
        fetchFirstPageResults,
        handleKeyStroke,
        handleFetchNextPage,
    } = useCustomFieldQuery({
        fieldEId: props.fieldEId,
        objectType: OBJECT_TYPE_MAP[props.objectType] as 'Candidate' | 'Job', // We know this will be either since this component wont render if not set
    })

    useEffect(() => {
        fetchSelectedResults('')
    }, [])

    const transformedData = useTransformCustomFieldValues({ data })

    const keyLabelMap = useTransformFieldValuesMap({ data })
    const selectedKeyLabelMap = useTransformFieldValuesMap({ data: selectedData })
    const handleSelect = (options: Array<any>) => {
        props.onChange(options)
        setData(transformKeyValueList(options, keyLabelMap, selectedKeyLabelMap))
    }

    return (
        <RootDropDownStatement>
            <AutoComplete 
                fieldLabel={ValueLabel}
                placeholder={ValueLabel}
                disabled={isReadOnly}
                multiple={true}
                options={transformedData}
                value={props.values}
                selectedIdKey="key"
                paginated
                onKeyStroke={handleKeyStroke}
                getOptionLabel={option => keyLabelMap[option] || selectedKeyLabelMap[option]}
                getValueLabel={option => keyLabelMap[option] || selectedKeyLabelMap[option]}
                onOpen={() => {fetchFirstPageResults('')}}
                onSelect={handleSelect}
                onFetchNextPage={handleFetchNextPage}
                loadingResults={resultsLoading && selectedResultsLoading}
                loadingNextPage={pageLoading && selectedPageLoading}
                currentPage={currentPage}
                noResults={data.length === 0}
                debounceInput
                hasError={Boolean(props.valueError) && props.valueError.errors.length > 0}
                ariaLabelNoResults={AdminNoResults}
            />
        </RootDropDownStatement>
    )
}

const transformKeyValueList = (data, keyLabelMap, selectedKeyLabelMap) => {
    const list = []
    if (!data) return list
    if (!Array.isArray(data)) return list
    for (let i = 0; i < data.length; i++) {
        const key = data[i]
        list.push({ 'key': key, 'value': keyLabelMap[key] || selectedKeyLabelMap[key]})
    }
    return list
}

export default DropDownStatement